import { atom } from 'recoil';

export const messageAtom = atom({
  key: 'messageAtom', 
  default: {
    message: '',
    type: '',
    time: 5
  },
});